module.exports = __webpack_public_path__ + "static/media/D-DIN.d68d8669.otf";